import { render, staticRenderFns } from "./ReservationColumnInputForm.vue?vue&type=template&id=15585b92&scoped=true&"
import script from "./ReservationColumnInputForm.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnInputForm.vue?vue&type=style&index=0&id=15585b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15585b92",
  null
  
)

export default component.exports